import { render, staticRenderFns } from "./AddPositionComponent.vue?vue&type=template&id=03461642"
import script from "./AddPositionComponent.vue?vue&type=script&lang=js"
export * from "./AddPositionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports